<template>
  <div>
    <div class="text-center my-10">
      <h1 class="page-title text-primary">Unsere Arbeiten</h1>
      <p class="page-subtitle">
        Maßgefertigte Möbel und Innenausbau aus unserer Schreinerei in Pfullingen
      </p>
    </div>

    <v-card class="bg-surface pa-6 pa-md-8 mb-8 card-clean" elevation="1">
      <p class="body-text">
        Jedes Projekt ist einzigartig – genau wie die Menschen, für die wir arbeiten.
        Hier finden Sie eine Auswahl unserer bisherigen Arbeiten: von Massivholztischen
        und Sideboards über Badmöbel bis hin zu kompletten Einrichtungen. Alle Stücke
        werden in unserer Werkstatt in Pfullingen bei Reutlingen gefertigt.
      </p>
    </v-card>

    <div v-for="project in projects" :key="project.name">
      <Product
        :imgHeight="$vuetify.display.mobile ? '350px' : '600px'"
        :product-name="project.name"
        :img-src="project.imgSrc"
      ></Product>
    </div>

    <v-card class="bg-primary pa-6 pa-md-8 my-8 card-clean text-center" elevation="0">
      <h2 class="text-accent mb-2">Ihr Projekt könnte das nächste sein</h2>
      <p class="body-text text-accent mb-5" style="opacity: 0.85">
        Sie haben eine Idee für ein Möbelstück oder einen Innenausbau?
        Sprechen Sie uns an – wir setzen Ihre Vorstellungen in die Tat um.
      </p>
      <div class="d-flex flex-column flex-md-row justify-center align-center">
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          href="tel:+4915778204841"
        >
          <v-icon start>mdi-phone</v-icon>
          +49 1577 8204841
        </v-btn>
        <v-btn
          size="large"
          class="bg-accent text-primary ma-2"
          to="/contact"
        >
          <v-icon start>mdi-email</v-icon>
          Jetzt Kontakt aufnehmen
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
import Product from "../components/Product.vue";

export default {
  name: "Products",
  components: {
    Product,
  },
  setup: () => {
    const allProjects = require("../projects.csv");
    let projects = [];
    for (let project of allProjects.filter((p) => p.project.toLowerCase() == "true")) {
      projects.push({
        name: project.name,
        imgSrc: project.imgSrc.split(",").map((i) => project.name + "_" + i),
        description: project.description,
      });
    }
    return { projects };
  },
};
</script>

<style scoped>
.page-title {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: clamp(1.5em, 5vw, 2.5em);
  font-weight: 400;
}

.page-subtitle {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 1em;
  opacity: 0.6;
  margin-top: 0.5rem;
}

.card-clean {
  border-radius: 12px;
}

.body-text {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 1em;
  line-height: 1.7;
}
</style>
